import { pilotAccess } from "@/lib/pilot-access";
import { Features, User } from "@/types";

export function hasAccess(
  user?: User | null,
  requiredFeatures: (keyof Features)[] = [],
  ...canView: boolean[]
): boolean {
  const pilotWithoutPlan = !user?.subscription?.is_active && (pilotAccess(user).hasPilot || user?.pilot_read_only);
  if (!user?.is_trial && !pilotWithoutPlan) {
    if (user?.subscription) {
      const features = user.subscription.features ?? ({} as Features);

      const hasRequiredFeatures = user.subscription?.features
        ? requiredFeatures.every((feature) => features[feature] === true)
        : false;

      if (hasRequiredFeatures) {
        return canView.some((permission) => permission);
      }

      return false;
    }

    return false;
  }

  return canView.some((permission) => permission);
}
